import { Component } from '@angular/core';
import { Modal } from '@indice/ng-components';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-unavailable-service',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './unavailable-service.component.html',
  styleUrl: './unavailable-service.component.css'
})
export class UnavailableServiceComponent {

  constructor(
    public modalRef: Modal,
    // @Inject(ModalOptions) private _options: ModalOptions,
  ) {}

  close = () => this.modalRef.hide();
}
